<template>
  <div>
    <client-only>
      <NativeBack
        :state="[value]"
        :close-methods="[emitHideModal]"
        @finishHiddenModal="finishHiddenModal"
      />
    </client-only>
    <transition
      name="fade"
      appear
    >
      <div
        v-if="open"
        class="modaltor"
        :class="[`modaltor--${animationParent}`, { 'modaltor--show': open }]"
      >
        <div
          :class="['modaltor__overlay']"
          :style="{ backgroundColor: bgOverlay }"
          @click="emitHideModal"
        />
        <div
          :class="['modaltor__panel', `modaltor__panel--${animationPanel}`,
                   `modaltor__panel--overflow-${overflow}`,

                   { 'modaltor__panel--is-full': isFull,
                     'modaltor__panel--mobile-full': mobileFull,
                     'modaltor__panel--show': open, 'not-rounded': !isRounded}]"
          :style="{ width: width, backgroundColor: bgPanel }"
        >
          <div class="modaltor__header">
            <slot name="header">
              <div
                class="modaltor__close"
                @click="emitHideModal"
              >
                x
              </div>
            </slot>
          </div>
          <div class="modaltor__content">
            <slot name="body" />
          </div>
          <div
            v-if="$slots.footer"
            class="modaltor__footer"
          >
            <slot name="footer" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import NativeBack from './click-back'
export default {
  name: 'Modulator',
  components: { NativeBack },
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    isRounded: {
      type: Boolean,
      required: false,
      default: true
    },
    isFull: {
      type: Boolean,
      required: false,
      default: false
    },
    mobileFull: {
      type: Boolean,
      required: false,
      default: false
    },
    resizeWidth: {
      type: Object,
      default: () => {}
    },
    animationPanel: {
      type: String,
      required: false,
      default: 'modal__fade'
    },
    overflow: {
      type: String,
      required: false,
      default: ''
    },
    bgOverlay: {
      type: String,
      required: false,
      default: '#fff'
    },
    bgPanel: {
      type: String,
      required: false,
      default: 'rgba(255, 255, 255, 0.57)'
    },
    animationParent: {
      type: String,
      required: false,
      default: 'modal__fade'
    },
    defaultWidth: {
      type: String,
      required: false,
      default: '80%'
    },
    closeScroll: {
      type: Boolean,
      required: false,
      default: true
    },
    spaceScroll: {
      type: String,
      required: false,
      default: '8px'
    }
  },
  data () {
    return {
      width: this.defaultWidth || '80%',
      open: false,
      backups: {
        body: {
          height: null,
          overflow: null,
          paddingRight: null
        }
      },
      timout: null
    }
  },
  watch: {
    defaultWidth (val) {
      this.setWith(val)
    },
    value (val) {
      if (val) {
        this.openModal()
      } else {
        this.hiddenModal()
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
  },
  destroyed () {
    this.destroyModal()
  },
  mounted () {
    this.$nextTick(function () {
      if (this.value) {
        this.openModal()
      }
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
      this.setWith(this.defaultWidth)
    })
  },
  methods: {
    updateValue (val) {
      this.$emit('update', val)
      // if(!val){
      //   this.$nextTick(()=>{
      //     this.finishHiddenModal()
      //   })
      // }
    },
    emitHideModal () {
      this.$emit('hideModal')
      this.destroyModal()
    },
    finishHiddenModal () {
      this.$emit('finishHidden')
    },
    destroyModal () {
      if (this.open) {
        if (this.closeScroll) {
          this._unlockBody()
        }
        this.open = false
        this.updateValue(false)
      }
    },
    hiddenModal () {
      if (this.closeScroll) {
        this._unlockBody()
      }
      this.open = false
      this.updateValue(false)
    },
    openModal () {
      this.open = true
      if (this.closeScroll) {
        this._lockBody()
      }
    },
    setWith (val) {
      const windowWidth = document.documentElement.clientWidth
      if (this.mobileFull && windowWidth <= 760) {
        this.width = '100%'
      } else {
        this.width = val
      }
    },
    getWindowWidth () {
      if (this.resizeWidth && Object.keys(this.resizeWidth).length > 0) {
        this.windowWidth = document.documentElement.clientWidth
        const filter = Object.keys(this.resizeWidth).find(f => f >= this.windowWidth)
        if (filter) {
          this.width = this.resizeWidth[filter]
        } else {
          this.width = this.defaultWidth
        }
      }
    },
    _hasScrollbar () {
      return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)
    },
    _lockBody () {
      if (this._hasScrollbar()) {
        this.backups.body.height = document.body.style.height
        this.backups.body.overflow = document.body.style.overflow
        document.body.style.paddingRight = this.spaceScroll
        document.body.style.height = '100%'
        document.body.style.overflow = 'hidden'
        document.body.classList.add('modalIsOpen')
      }
    },
    _unlockBody () {
      if (this._hasScrollbar()) {
        document.body.style.height = this.backups.body.height
        document.body.style.overflow = this.backups.body.overflow
        document.body.style.paddingRight = this.backups.body.paddingRight
        document.body.classList.remove('modalIsOpen')
      }
    }
  }
}
</script>
<style lang="scss">
.modaltor {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  z-index: 99;
  -webkit-transform: translate3D(0, 0, 0);
  -ms-transform: translate3D(0, 0, 0);
  -o-transform: translate3D(0, 0, 0);
  transform: translate3D(0, 0, 0);
  transition: all 0.2s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modaltor--fade {
  opacity: 0.1;
  visibility: hidden;
}

.modaltor--scale {
  -webkit-transform: scale(-1, 1);
  -ms-transform: scale(-1, 1);
  -o-transform: scale(-1, 1);
  transform: scale(-1, 1);
}

.modaltor--show {
  visibility: visible;
  opacity: 1;
  -webkit-transform: translate3D(0, 0, 0);
  -ms-transform: translate3D(0, 0, 0);
  -o-transform: translate3D(0, 0, 0);
  transform: translate3D(0, 0, 0);
}

.modaltor--show {
  &.modaltor--show,
  &.modaltor--scale {
    visibility: visible;
    opacity: 1;
    -webkit-transform: translate3D(0, 0, 0);
    -ms-transform: translate3D(0, 0, 0);
    -o-transform: translate3D(0, 0, 0);
    transform: translate3D(0, 0, 0);
  }
}

.modaltor__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  font-size: 14px;
  z-index: 999;
}

.modaltor__panel {
  z-index: 999;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 8px 46px rgba(0, 0, 0, 0.08), 0px 2px 6px rgba(0, 0, 0, 0.03);
  position: absolute;
  overflow-y: auto;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  transition-property: transform, opacity, width;
  transition-duration: 0.3s;
  transition-delay: 0.05s;
  transition-timing-function: cubic-bezier(0.52, 0.02, 0.19, 1.02);
  @apply rounded;
  .not-rounded {
    @apply rounded-none;
  }
  &--mobile-full {
    @apply rounded-none lg:rounded flex flex-col;
    .modaltor__content {
      @apply flex-1;
    }
  }
}

.modaltor__panel:not(.modaltor__panel--is-full) {
  max-height: 90vh;
  top: 50%;
}

// Increase max height for tutor list teacher suggestion modal
.tutor-list{
  .modaltor__panel:not(.modaltor__panel--is-full){
    @screen lg {
      max-height: 95vh;
    }
  }
}

.modaltor__panel--is-full {
  @screen lg {
    max-height: 90vh;
    top: 50%;
    bottom: inherit;
  }
  top: 0;
  bottom: 0;
}

.modaltor__panel--is-full.modaltor__panel--show {
  visibility: visible;
  opacity: 1;
  @screen lg {
    transform: translate(0, -50%) !important;
  }
}

.modaltor__panel--overflow-visible {
  overflow: visible;
}

.modaltor__panel--show:not(.modaltor__panel--is-full) {
  transform: translate(0, -50%) !important;
  opacity: 1 !important;
}

.modaltor__panel--fade {
  transform: scale(1) translate(0, -50%);
}

.modaltor__panel--rotate {
  transform: rotate(45deg) translate(0, -50%);
}

.modaltor__panel--slide-right {
  transform: translate(100px, -50%);
}

.modaltor__panel--slide-left {
  transform: translate(-100px, -50%);
}

.modaltor__panel--slide-top {
  transform: translate(0, -100%);
}

.modaltor__panel--slide-bottom {
  transform: translate(0, -100%);
}

/* ---------------------------------- */
.fadeModal-enter-active,
.fadeModal-leave-active {
  transition: opacity .4s linear;
}

.fadeModal-enter,
.fadeModal-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0);
}
</style>
